export default __webpack_public_path__ + "static/902-6ed6507feea4260a1aae848b33770537.gif";